import React from "react";
import './Input.scss';

export const Input = (props) => {
  return (
    <input 
      className={`${props.className} form_control`} 
      type="text" 
      placeholder={props.placeholder}  
      value={props.value} 
      onChange={props.onChange}
      onClick={props.onClick}
      onPaste={props.onPaste}
      onKeyUp={props.onKeyUp}
      onKeyDown={props.onKeyDown} 
      readOnly={props.readOnly}
      maxLength={props.maxLength} />
  );
};